import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#2C3E50] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka One, cursive' }}>
              Scratchflix
            </h3>
            <p className="text-white/80 text-sm leading-relaxed">
              Projet d'entreprise scolaire<br />
              École Notre-Dame des Champs<br />
              Uccle, Belgique
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#accueil" className="text-white/80 hover:text-white transition-colors">
                  Accueil
                </a>
              </li>
              <li>
                <a href="#qui-sommes-nous" className="text-white/80 hover:text-white transition-colors">
                  Qui sommes-nous
                </a>
              </li>
              <li>
                <a href="#tutoriels" className="text-white/80 hover:text-white transition-colors">
                  Tutoriels
                </a>
              </li>
              <li>
                <a href="#creations" className="text-white/80 hover:text-white transition-colors">
                  Nos Créations
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Ressources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://scratch.mit.edu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Scratch.mit.edu
                </a>
              </li>
              <li>
                <a
                  href="https://scratch.mit.edu/ideas"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Apprendre Scratch
                </a>
              </li>
              <li>
                <a
                  href="https://scratch.mit.edu/discuss/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Communauté Scratch
                </a>
              </li>
              <li>
                <a
                  href="https://en.scratch-wiki.info/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Scratch Wiki
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <p className="text-sm text-white/70 text-center sm:text-left">
              © 2024 Scratchflix | Réalisé avec ❤️ par Victor, Lise & Juliette | École Notre-Dame des Champs
            </p>
            <img 
              src={process.env.PUBLIC_URL + "/scratchflix-logo.png"} 
              alt="Scratchflix" 
              className="h-20 w-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;